<app-curve-chart [entityType]="entityType"></app-curve-chart>
